import React, { useEffect, useState } from "react";

import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import ItemsRequestForm from "./itemsRequestForm";
import Swal from "sweetalert2";
import ItemRequestProcessForm from "./itemRequestProcessForm";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import { Badge } from "react-bootstrap";
import {
  getItemsRequest,
  cancelItemRequest,
} from "../../../../../services/inventory/itemReservationService";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import Illustration from "../../../../../partials/content/Illustration";
function ItemsRequestList({
  operationCardID = 0,
  productionOrderID = 0,
  batchID = 0,
  salesOrderItem = {
    ID: 0,
    itemID: 0,
    itemName: "",
    varCode: "",
    qty: 0,
    uomID: 0,
    uomName: "",
    item: {
      itemType: 0,
    },
  },
  customerID = 0,
  warehouse = {
    ID: 0,
    warehouseName: "",
  },
}) {
  const { reload } = useGlobalData();
  const [openItemsRequestForm, setOpenItemsRequestForm] = useState(false);
  const [openItemRequestProcessForm, setOpenItemRequestProcessForm] = useState(
    false
  );
  const [itemsRequest, setItemsRequest] = useState([]);
  const [itemRequest, setItemRequest] = useState({
    itemID: 0,
    varCode: "",
    item: {
      itemName: "",
    },
    uom: { uom: "" },
    salesOrder: {
      customerID: 0,
    },
  });

  const itemsRequestDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  useEffect(() => {
    if (operationCardID > 0 || productionOrderID > 0) {
      getItemsRequestData(
        operationCardID,
        salesOrderItem.ID,
        warehouse.ID,
        productionOrderID
      );
    }
  }, [
    operationCardID,
    productionOrderID,
    salesOrderItem.ID,
    warehouse.ID,
    reload,
  ]);

  return (
    <React.Fragment>
      {itemsRequest.length ? (
        <React.Fragment>
          <CustomDataTable
            data={itemsRequest}
            buttons={[
              {
                name: "New Items Request",
                onClick: () => {
                  setOpenItemsRequestForm(true);
                },
                icon: "fas fa-plus-circle",
                color: "primary",
              },
            ]}
            onRefreshData={() => {
              if (operationCardID > 0) {
                getItemsRequestData(
                  operationCardID,
                  salesOrderItem.ID,
                  warehouse.ID
                );
              }
            }}
            dataDetailColumns={itemsRequestDetailColumn}
            columns={[
              {
                header: "Reservation ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Warehouse Name",
                field: "warehouse.warehouseName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.warehouse.warehouseName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Reservation Status",
                field: "statusID",
                body: (rowData) => (
                  <React.Fragment>
                    <Badge
                      variant={
                        rowData.statusID === 1
                          ? "warning"
                          : rowData.statusID === 2
                          ? "primary"
                          : rowData.statusID === 3
                          ? "success"
                          : rowData.statusID === 9
                          ? "danger"
                          : null
                      }
                    >
                      {rowData.statusName}
                    </Badge>
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Type",
                field: "itemTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.itemTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Item Code",
                field: "itemCode",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.itemType > 0 ? (
                      <span>
                        <BootstrapTooltip title={rowData.itemTypeName}>
                          <span className="mr-2">
                            <i
                              className={
                                rowData.itemType === 1
                                  ? "fas fa-boxes text-success"
                                  : rowData.itemType === 2
                                  ? "fas fa-tools text-primary"
                                  : rowData.itemType === 3
                                  ? "fas fa-building text-info"
                                  : rowData.itemType === 4
                                  ? "fas fa-boxes text-warning"
                                  : rowData.itemType === 5
                                  ? "fas fa-boxes text-danger"
                                  : null
                              }
                            ></i>
                          </span>
                        </BootstrapTooltip>
                        <span>
                          <ResponsiveEllipsis
                            text={rowData.itemCode}
                            maxLine="1"
                            displayInline
                          />
                        </span>
                      </span>
                    ) : (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemCode}
                          maxLine="1"
                        />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Name",
                field: "itemName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Quantity",
                field: "qty",
                body: (rowData) => (
                  <div>
                    {rowData.qty} {rowData.uom.uom}
                  </div>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit",
                field: "uom.uom",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.statusID < 3 &&
                    warehouse.ID > 0 &&
                    warehouse.ID === rowData.warehouseID ? (
                      <BootstrapTooltip title="Process Requested Items">
                        <button
                          type="button"
                          onClick={() => {
                            setItemRequest(rowData);
                            setOpenItemRequestProcessForm(true);
                          }}
                          className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-cogs"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    {rowData.statusID === 1 ? (
                      <BootstrapTooltip title="Reject Requested Items">
                        <button
                          type="button"
                          onClick={() => {
                            cancelRequest(rowData);
                          }}
                          className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-window-close"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Inventory.png"
            description="Hooray! You're ready to have your first Items Request from this operation!"
            guidance="Hint: manage your items request to the warehouses to maximize collaboration"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
            size="sm"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                setOpenItemsRequestForm(true);
              }}
            >
              <i className="fas fa-plus-circle"></i>
              New Items Request
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openItemsRequestForm}
        title="Items Request Form"
        onCloseDialog={() => {
          setOpenItemsRequestForm(false);
        }}
      >
        <ItemsRequestForm
          operationCardID={operationCardID}
          batchID={batchID}
          productionOrderID={productionOrderID}
          customerID={customerID}
          salesOrderItem={salesOrderItem}
          warehouseID={warehouse.ID}
          warehouseName={warehouse.warehouseName}
          onCloseDialog={() => {
            setOpenItemsRequestForm(false);
          }}
          onConfirmSave={() => {
            getItemsRequestData(
              operationCardID,
              salesOrderItem.ID,
              warehouse.ID
            );
            setOpenItemsRequestForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openItemRequestProcessForm}
        title="Item Request Process Form"
        onCloseDialog={() => {
          setOpenItemRequestProcessForm(false);
        }}
        fullScreen={false}
      >
        <ItemRequestProcessForm
          itemRequestID={itemRequest.ID}
          batchID={batchID}
          warehouseID={warehouse.ID}
          warehouseName={warehouse.warehouseName}
          onCloseDialog={() => {
            setOpenItemRequestProcessForm(false);
          }}
          onConfirmSave={() => {
            getItemsRequestData(
              operationCardID,
              salesOrderItem.ID,
              warehouse.ID
            );
            setOpenItemRequestProcessForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function cancelRequest(rowData) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to reject this Items Request ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, reject it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelItemRequest(rowData.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Rejected",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getItemsRequestData(
              operationCardID,
              salesOrderItem.ID,
              warehouse.ID
            );
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getItemsRequestData(
    operationCardID = 0,
    salesOrderItemID = 0,
    warehouseID = 0,
    productionOrderID = 0
  ) {
    const response = await getItemsRequest(
      operationCardID,
      salesOrderItemID,
      warehouseID,
      0,
      productionOrderID
    );
    const { data } = response.data;
    const { itemsRequest } = data;
    setItemsRequest(itemsRequest);
  }
}

export default ItemsRequestList;
